<template>
  <div>
    <div class="camera-button">
      <b-button
        type="button"
        class="mt-2 p-2"
        variant="primary"
        :class="{ 'is-primary': !isCameraOpen, 'is-danger': isCameraOpen }"
        @click="toggleCamera"
      >
        <span v-if="!isCameraOpen">Включити камеру</span>
        <span v-else>Закрити камеру</span>
      </b-button>
      <div v-if="isCameraOpen" class="camera-box mt-2">
        <video ref="camera" :width="450" :height="337.5" autoplay></video>
        <h3 v-show="isPhotoTaken" class="mt-2">Зняте фото</h3>
        <canvas
          v-show="isPhotoTaken"
          id="photoTaken"
          ref="canvas"
          :width="450"
          :height="337.5"
        ></canvas>
      </div>
      <div v-if="isCameraOpen" class="camera-shoot">
        <b-button
          variant="success"
          type="button"
          class="m-2"
          @click="takePhoto"
        >
          <img
            src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png"
          />
        </b-button>
        <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
          <a
            id="downloadPhoto"
            download="my-photo.jpg"
            class="button m-2"
            role="button"
            @click="downloadImage"
          >
            Завантажити
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CameraMan",
  data: function () {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
    };
  },
  computed: {
    ...mapState(["current_client"]),
  },
  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          alert(error);
        });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },
    takePhoto() {
      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },
    downloadImage() {
      const canvas = document.getElementById("photoTaken");

      canvas.toBlob(
        (blob) => {
          console.log(blob);

          this.$emit("photoTaken", blob);
        },
        "image/png",
        0.95,
      );
      // .replace("image/jpeg", "image/octet-stream");
    },
  },
};
</script>

<style scoped>
button {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 35px;
    object-fit: cover;
  }
}
</style>
